var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"w-full",attrs:{"options":_vm.areaOptions,"label":"name"},model:{value:(_vm.area),callback:function ($$v) {_vm.area=$$v},expression:"area"}})}
var staticRenderFns = []

export { render, staticRenderFns }